import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";

const baseStyle = defineStyle({
  maxWidth: "1360px",
  px: { mobile: "0", desktop: "10" },
})

export const Container = defineStyleConfig({
  baseStyle,
});
